import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "processd" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "tips" }
const _hoisted_5 = { class: "tips" }
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = {
  class: "flex-end",
  style: {"padding":"20px 0"}
}
const _hoisted_8 = ["src"]

import { t, lang } from '@/plugins/i18n'
import {
  regularizationInvalid
} from '@/apis/stock'


import { ElMessage } from 'element-plus'
import { defineComponent, defineProps, defineEmits, reactive, ref, computed, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  processedData: {
    type: Array,
    default: () => {
      return []
    }
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit: emits }) {

const props = __props

const closeImg = ref()
closeImg.value = require('@/assets/image/icon/close.svg')


const submitRegularizationInvalid = function () {
  const params = props.processedData.map((item: any) => {
    return item.pkgCode
  })
  regularizationInvalid(params).then((res: any) => {
    if (res.success) {
      ElMessage.success({ dangerouslyUseHTMLString: true, message: `<strong>${t('已作废成功')}！</strong>` })
      emits('refresh')
      emits('update:visible', false)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "model-value": __props.visible,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (emits('update:visible', false))),
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('您确定作废该批次的次品吗？')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('次品作废后将不可转正品，不可退还，')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('THE CKB平台有权自行处理，且无任何经济纠纷，')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('请慎重操作！')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', false)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submitRegularizationInvalid
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("img", {
            src: closeImg.value,
            alt: "",
            class: "closeImg",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false)))
          }, null, 8, _hoisted_8)
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})